import { helpers, pr, theme, ui } from "aaa";
import { AliasStore } from "components/alias/AliasStore";
import { observer } from "mobx-react";
import * as React from "react";
import { useRouteMatch } from "react-router";
import profileStore from "stores/ProfileStore";
import { pushRoute } from "stores/RouterFunctions";
import toastSore from "stores/ToastStore";
import { SettingsButton } from "./SettingsButton";
import { SettingsButtonIcon } from "./SettingsButtonIcon";
import { SettingsButtonsContainer } from "./SettingsButtonsContainer";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { CardTanSettingsRoutes } from "../cardTanSettings/CardTanSettingsRoutes";

const SettingTitle = ({ children }: { children: React.ReactNode }) => (
    <pr.P_16_TITLE style={{ color: ui.isDarkMode ? "white" : "#0A285C", fontWeight: 500 }}>{children}</pr.P_16_TITLE>
);

const SettingSubTitle = ({ children }: { children: React.ReactNode }) => (
    <pr.P_14_CONTENT >{children}</pr.P_14_CONTENT>
);

const ActionText = ({ children }: { children: React.ReactNode }) => (
    <pr.P_16_CONTENT style={{ color: "#135EE2", fontWeight: 500 }}>{children}</pr.P_16_CONTENT>
);

export const Settings = observer(({
    store,
    limit,
    limitManagementRoute,
    showLimit,
    style
}: {
    store: AliasStore,
    limit: string,
    limitManagementRoute: string,
    showLimit?: boolean,
    style?: React.CSSProperties
}) => {
    const authorizationType = externalInterfaceStore.settings?.authorizationType;
    const match = useRouteMatch();

    const isMobile = ui.windowWidth < 600;

    const editAction = isMobile
        ? <pr.IconChevronRight style={{ color: "#A7B6C7" }} />
        : <ActionText>{ui.__("common.edit")}</ActionText>;

    return (
        <SettingsButtonsContainer style={style}>
            <SettingsButton border="bottom" borderRadius="top" variant="dense">
                <pr.P_18_TITLE style={{ fontWeight: 700 }}>
                    {ui.__("sidentitySettings.settings")}
                </pr.P_18_TITLE>
            </SettingsButton>
            {showLimit && (
                <SettingsButton
                    border="bottom"
                    borderRadius="none"
                    onClick={() => pushRoute(limitManagementRoute)}
                    icon={<SettingsButtonIcon src={require("assets/arrows.svg")} />}
                >
                    <div style={{ flex: 1 }}>
                        <SettingTitle>{ui.__("sidentitySettings.dailyLimit")}</SettingTitle>
                        <SettingSubTitle>{limit}</SettingSubTitle>
                    </div>
                    {editAction}
                </SettingsButton>
            )}
            <SettingsButton
                border="bottom"
                borderRadius="none"
                onClick={() => {
                    if (profileStore.profile) {
                        helpers.copyTextToClipboard(profileStore.profile?.userNumber.toString() ?? "");
                        toastSore.addMessage(ui.__("sidentitySettings.usernumberCopied"));
                    }
                }}
                icon={<pr.IconUser style={{ color: "#135EE2", flexShrink: 0 }} />}
            >
                <div style={{ flex: 1 }}>
                    <SettingTitle>{ui.__("common.usernumber")}</SettingTitle>
                    <SettingSubTitle>{profileStore.profile?.userNumber}</SettingSubTitle>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <pr.IconCopy2 style={{ color: "#135EE2" }} />
                    {!isMobile && (
                        <ActionText>{ui.__("common.copy")}</ActionText>
                    )}
                </div>
            </SettingsButton>
            {!store.currentUsername && (
                <SettingsButton
                    border={authorizationType === "CARDTAN" ? "bottom" : "none"}
                    borderRadius={authorizationType === "CARDTAN" ? "none" : "bottom"}
                    onClick={() => {
                        pushRoute(`${match.path}/username`);
                    }}
                    icon={<SettingsButtonIcon src={require("assets/plus.svg")} />}
                >
                    <div style={{ flex: 1 }}>
                        <SettingTitle>{ui.__("sidentitySettings.addUsername")}</SettingTitle>
                    </div>
                    {editAction}
                </SettingsButton>
            )}
            {!!store.currentUsername && (
                <SettingsButton
                    border={authorizationType === "CARDTAN" ? "bottom" : "none"}
                    borderRadius="none"
                    onClick={() => {
                        pushRoute(`${match.path}/username`);
                    }}
                    icon={<pr.IconLockClosed style={{ color: "#135EE2", flexShrink: 0 }} />}
                >
                    <div style={{ flex: 1 }}>
                        <SettingTitle>{ui.__("common.username")}</SettingTitle>
                        <SettingSubTitle>{profileStore.profile?.alias}</SettingSubTitle>
                    </div>
                    {editAction}
                </SettingsButton>
            )}
            {authorizationType === "CARDTAN" && (
                <>
                    <SettingsButton
                        border="bottom"
                        borderRadius="none"
                        onClick={() => {
                            pushRoute(CardTanSettingsRoutes.CHANGE_PIN);
                        }}
                        icon={<pr.IconPin style={{ color: "#135EE2", flexShrink: 0 }} />}
                    >
                        <div style={{ flex: 1 }}>
                            <SettingTitle>{ui.__("cardTanSettings.setting.pin")}</SettingTitle>
                        </div>
                        {editAction}
                    </SettingsButton>
                    <SettingsButton
                        border="bottom"
                        borderRadius="none"
                        onClick={() => {
                            pushRoute(CardTanSettingsRoutes.CARDS);
                        }}
                        icon={<pr.IconCreditCard style={{ color: "#135EE2", flexShrink: 0 }} />}
                    >
                        <div style={{ flex: 1 }}>
                            <SettingTitle>{ui.__("cardTanSettings.setting.debitCards")}</SettingTitle>
                        </div>
                        {editAction}
                    </SettingsButton>
                    <SettingsButton
                        border="none"
                        borderRadius="bottom"
                        onClick={() => {
                            pushRoute(CardTanSettingsRoutes.NEW_DEVICE);
                        }}
                        icon={<pr.IconPlus style={{ color: "#135EE2", flexShrink: 0 }} />}
                    >
                        <div style={{ flex: 1 }}>
                            <SettingTitle>{ui.__("cardTanSettings.setting.newDevice")}</SettingTitle>
                        </div>
                        {editAction}
                    </SettingsButton>
                </>
            )}
        </SettingsButtonsContainer>
    );
});


// WEBPACK FOOTER //
// ./src/components/loginManagement/components/Settings.tsx